import { declareEndpoint } from './BridgeProxy.Types';
import * as a from 'core/api';

type ShowNotification = {
	type: 'ShowNotification',
	date: Date
}

type HideNotification = {
	type: 'HideNotification',
	date: Date
}

type Audit = {
	type: 'Audit',
	date: Date,
	eventType: a.AuditEventType,
	action: string,
	details: string
}

type InputOperation = {
	type: 'InputOperation',
	date: Date,
	provider: string,
	description: string,
	amount: number,
	printReceipt: boolean
}

type OutputOperation = {
	type: 'OutputOperation',
	date: Date,
	provider: string,
	description: string,
	amount: number,
	printReceipt: boolean
}

type FixPosAmount = {
	type: 'FixPosAmount',
	date: Date
}

type PrintCloseDayResult = {
	type: 'PrintCloseDayResult',
	date: Date,
	remainingChange: number,
	coinsValues: number,
	notesValues: number
}

export type CashControlAction = ShowNotification | HideNotification | Audit | InputOperation | OutputOperation | FixPosAmount | PrintCloseDayResult;

export type ReaderStatus = {
	verifiedUserId: number | null,
	message: string,
	failure: string
}


export const Endpoints = {
	Environment: {
		Close: declareEndpoint<void, void>('/environment/close'),
		IsAlive: declareEndpoint<void, { id: string }>('/environment/is-alive'),
		SetLanguageCode: declareEndpoint<{ languageCode: string }, void>('/environment/set-language-code')
	},
	CardProcessor: {
		Transaction: declareEndpoint<{ amount: number, posReference: string, userReference: string, transactionType: string, relatedTransactionXmlDetails: string, transactionId: string, askGratuity: boolean }, { ok: boolean, transactionId: string, xmlDetails: string, transactionType: number }>('/card-processor/transaction')
	},
	CustomerDisplay: {
		Display: declareEndpoint<{ line1: string, line2: string }, void>('/customer-display/display')
	},
	Fingerprint: {
		Status: declareEndpoint<void, { status: ReaderStatus }>('/fingerprint/status')
	},
	Scale: {
		CurrentWeight: declareEndpoint<void, { kgs: number, isStable: boolean }>('/scale/current-weight')
	},
	CashControl: {
		CloseDay: declareEndpoint<{ canOpenCashDrawers: boolean }, { pendingActions: CashControlAction[] }>('/cash-control/close-day'),
		CurrentAmount: declareEndpoint<void, { amount: number, success: boolean }>('/cash-control/current-amount'),
		GiveChange: declareEndpoint<void, { pendingActions: CashControlAction[] }>('/cash-control/give-change'),
		PendingActions: declareEndpoint<void, { pendingActions: CashControlAction[] }>('/cash-control/pending-actions'),
		Operations: declareEndpoint<{ canShowStatus: boolean, canAddChange: boolean, canShowAdvancedOptions: boolean, canReset: boolean }, { pendingActions: CashControlAction[] }>('/cash-control/operations'),
		Transaction: declareEndpoint<{ amountToPay: number }, { ok: boolean, paid: number, change: number, amountToPay: number, pendingActions: CashControlAction[] }>('/cash-control/transaction')
	}
};

